import url                             from '../../../utils/url.js'
import { MAP, TILE_LAYER }             from '@/config/map'
import { POLYGON }                     from '@/config/polygon'
import layersMixin                     from '../../../mixins/layers-mixin.js'
import { map as mapEndpoints }         from '../../../api/api-endpoints.js'
import measureMixin                    from '../mixins/measure-mixin'
import L                               from 'leaflet'
import { OBJECT_RENDERER, YANDEX_API } from '@/config/config'
import ObjectsSupeclasterLayerDrawer   from '@/utils/map/superclaster/ObjectsSupeclasterLayerDrawer'
import BaseLayerDrawer                 from '@/utils/map/BaseLayerDrawer'

export default {
  data() {
    this.searchExactEndpoint = id => mapEndpoints.searchExact(id)
    this.mapLayers = null
    this.map = null
    this.mapEndpoints = []
    this.objectDrawer = null
    return {
      suggestionMapSearch: { q: '' },
      q: '',
      layers: []
    }
  },
  mixins: [layersMixin, measureMixin],
  created() {
    this.setFiltersFromUrl()
    let promises = []
    let usedRoute = url.getPrevOrCurrentRoute(this.$route)
    if (usedRoute?.query?.layers) {
      let conf = this.getParentsConf(usedRoute.query.layers.split(','), this.getLayersConf())
      for (let key in conf) {
        const endpoint = this.getLayerEndpoint(conf, key, usedRoute)
        console.log(endpoint,'endpoint is ');
        promises.push(this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          cache: false,
          notReactive: false
        }))
      }
    }
    promises.push(this.$store.dispatch('updateUrlEndpoint', {
      endpoint: mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom),
      cache: true,
      fromCache: true
    }))
    
    return Promise.all(promises)
  },
  mounted() {
    this.$store.commit('preloaderOn', true)
  },
  computed: {
    userData() {
      return this.$store.getters?.userData || null
    },
    layerLegendItems() {
      if (!Object.keys(this.layerGroups).length) {
        return []
      }
      return this.layersWithData.filter(layer => this.layerGroups[layer])
    },
    layerGroups() {
      return Object.assign({}, ...Object.values(this.getLayersConf()).map(lC => lC.groups))
    },
    module() {
      return 'geo'
    },
    mapBorders() {
      return null
    }
  },
  methods: {
    suggestionEndpoint(ctx, q) {
      return mapEndpoints.search({ query: { q } })
    },
    transformSuggestions(ctx, data) {
      if (data) {
        return data.map(item => ({
          id: item.id,
          name: `${item.name || ''}`,
          address: item.address || '',
          type: item.type || ''
        }))
      }
    },
    async selectItemOnMapSearch($event) {
      this.suggestionMapSearch.q = $event.name
      this.$bar.start().set(12)
      try {
        let foundObject = (await this.$store.dispatch('updateUrlEndpoint', { endpoint: this.searchExactEndpoint($event.id) })).data
        let objectForMap = this.objectDrawer.createObjectForMap(foundObject)
        if (!objectForMap) {
          throw 'Объект не найден'
        }
        this.objectDrawer.bringToMarker(objectForMap, 12)
      } catch (e) {
        this.$e.errorBox(e)
      } finally {
        this.$bar.finish()
      }

    },
    getCopyWithoutObservers(data) {
      console.log('getCopyWithoutObservers')
      return JSON.parse(JSON.stringify(data))
    },
    getMapConfigData() {
      return MAP
    },
    getMapPolygon() {
      return POLYGON
    },
    drawTiles() {
      L.tileLayer(TILE_LAYER).addTo(this.map)
    },
    getLayersConf() {
      return {
        gs: {
          menuClass: 'oth',
          label: 'Отходообразователи',
          endpoint: mapEndpoints.source,
          className: 'cluster-marker',
          iconType: 'wasteCreators',
          groups: {
            org: {
              menuClass: 'oth-hoz',
              iconType: 'org',
              label: 'Организация/ИП',
              restApiOrder: 2
            },
            def: {
              menuClass: 'oth-minOb',
              iconType: 'def',
              label: 'Объекты министерства обороны',
              restApiOrder: 4
            },
            med: {
              menuClass: 'oth-med',
              iconType: 'med',
              label: 'Медицинские учреждения',
              restApiOrder: 5
            },
            uk: {
              iconType: 'uk',
              menuClass: 'oth-upOrg',
              label: 'Управляющие организации',
              restApiOrder: 1
            },
            ind: {
              menuClass: 'oth-individ',
              iconType: 'ind',
              label: 'Индивидуальное домовладение',
              restApiOrder: 6
            },
            country: {
              menuClass: 'oth-garden',
              iconType: 'country',
              label: 'Садовые, дачные партнерства',
              restApiOrder: 7
            },
            gsk: {
              menuClass: 'oth-garage',
              iconType: 'gsk',
              label: 'ГСК',
              restApiOrder: 8
            },
            set: {
              menuClass: 'oth-village',
              iconType: 'set',
              label: 'Деревни, поселки, села',
              restApiOrder: 3
            }
          }
        },
        msn: {
          iconType: 'places',
          menuClass: 'places',
          label: 'Места сбора и накопления',
          endpoint: mapEndpoints.msn,
          className: 'cluster-marker msn',
          groups: {
            container: {
              menuClass: 'places-cont',
              iconType: 'container',
              label: 'Контейнерные площадки',
              restApiOrder: 1
            },
            noContainer: {
              menuClass: 'places-noCont',
              iconType: 'noContainer',
              label: 'Бесконтейнерный сбор',
              restApiOrder: 2
            },
            separate: {
              menuClass: 'places-points',
              iconType: 'separate',
              label: 'Пункты сбора вторсырья',
              restApiOrder: 3
            },
            specialKgo: {
              menuClass: 'places-points',
              iconType: 'separate',
              label: 'Специальные площадки для КГО',
              restApiOrder: 7
            },
            garbageChambers: {
              menuClass: 'places-points',
              iconType: 'separate',
              label: 'Мусороприемные камеры',
              restApiOrder: 8
            },
          }
        },
        dump: {
          iconType: 'svalka',
          menuClass: 'svalka',
          label: 'Несанкционированные свалки',
          endpoint: mapEndpoints.heap,
          className: 'cluster-marker heap',
          groups: {
            heap: {
              menuClass: 'svalka-thrash',
              iconType: 'thrash',
              label: 'Навалы мусора',
              restApiOrder: 1
            },
            unauth: {
              endpoint: 'object',
              menuClass: 'svalka-noThrash',
              iconType: 'noThrash',
              label: 'Несанкционированные ОРО',
              restApiOrder: 2
            }
          }
        },
        object: {
          iconType: 'garbage',
          menuClass: 'obj',
          label: 'Объекты обращения с отходами',
          endpoint: mapEndpoints.object,
          className: 'cluster-marker object',
          groups: {
            process: {
              menuClass: 'obj-obrab',
              iconType: 'process',
              label: 'Объекты обработки',
              restApiOrder: 2
            },
            util: {
              menuClass: 'obj-utiliz',
              iconType: 'util',
              label: 'Объекты утилизации',
              restApiOrder: 5
            },
            neutral: {
              menuClass: 'obj-obezvr',
              iconType: 'neutral',
              label: 'Объекты обезвреживания',
              restApiOrder: 3
            },
            storage: {
              menuClass: 'obj-chran',
              iconType: 'storage',
              label: 'Объекты хранения',
              restApiOrder: 4
            },
            burial: {
              menuClass: 'obj-zachoron',
              iconType: 'burial',
              label: 'Объекты захоронения',
              restApiOrder: 6
            },
            mercury: {
              menuClass: 'obj-mercury',
              iconType: 'burial',
              label: 'Объекты обработки ртутных объектов',
              restApiOrder: 7
            }
          }
        },
        transport: {
          menuClass: 'transp',
          label: 'Транспортировщики',
          endpoint: mapEndpoints.transport,
          className: 'cluster-marker transport',
          iconType: 'transp',
          groups: {
            trans: {
              hideFromMenu: true,
              iconType: 'transport',
              label: 'Транспортировщики',
              restApiOrder: 1
            }
          }
        }
      }
    },
    destroyMap() {
      console.log('destroyed')
      this.$emitter.emit('geo.destroyMap', {})
      this.map.remove()
      this.map = null
    },
    async afterMapInit() {
      let mapScript = document.createElement('script')
      mapScript.setAttribute('src', YANDEX_API)
      document.head.appendChild(mapScript)
      this.initObjectsLayerDrawer()
      this.objectDrawer = this.getObjectDrawer()
      await this.setDataToLayersFromStore()
    },
    initObjectsLayerDrawer() {
      if (OBJECT_RENDERER === 'superclaster') {
        this.objectsLayerDrawer = new ObjectsSupeclasterLayerDrawer(this.map, { vm: this })
      } else {
        this.objectsLayerDrawer = new BaseLayerDrawer(this.map, { vm: this })
      }
      this.mapLayers = this.objectsLayerDrawer.setLayersConfigAndDraw(this.layersConf)
    },
    async onFormEvent(e) {
      if (e.action === 'onSaveForm' || e.action === 'onRemove') {
        if (this.objectsLayerDrawer) {
          this.objectsLayerDrawer.removeLayers()
        }
        
        this.$store.commit('deleteEndpoints', {
          endpoints: [
            mapEndpoints.objectCache()
          ]
        })
        await this.reCreateMap()
      }
    },
  
    /**
     * Need for show changes after postion of marker changed
     */
    async reCreateMap() {
      this.$store.commit('cleanCache')
      this.$store.commit('skipAsyncData', { name: `${this.module}.*`, depth: 1, value: false })
      this.$bar.start().set(12)
      let params = { layers: this.layers }
      await this.replaceRoute(params, false)
      this.$bar.finish()
      this.afterReCreateMap()
      this.initObjectsLayerDrawer()
    },
    getParentsConf(layersArr, conf) {
      return layersMixin.methods.getParentsConf(layersArr, conf)
    },
    getLayerEndpoint(conf, type, route) {
      return layersMixin.methods.getLayerEndpoint(conf, type, route)
    },
    afterReCreateMap() {
      // this.objectsLayerDrawer.removeLayers()
      // this.mapLayers = null
    },
    getMOEndpoint() {
      return mapEndpoints.mo()
    }
  },
}
